import { useCallback, useEffect, useState } from 'react';
import {
  verticalPackService,
  type ResolvedVerticalConfig,
} from '../services/verticalPackService';

export function useVerticalConfig() {
  const [config, setConfig] = useState<ResolvedVerticalConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const data = await verticalPackService.resolveVerticalConfig();
      setConfig(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load vertical config');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { config, loading, error, refresh };
}
